<div v-if="shouldRenderConfig" v-bind:class="[getClassName, (isStatus ? '' : valid ? '' : getClassName + 'Invalid')]">
    <div v-bind:class="getClassName + 'Label'">{{label}}</div>        
    <div v-bind:class="getClassName + 'Desc'">
        <div v-if="!isStatus" v-bind:class="getClassName + 'Header'"> 
            <div v-bind:class="getClassName + 'Name'">{{name}}</div>
            <span v-bind:class="getClassName + 'Icon'"></span>        
        </div>        
        <div v-if="!isStatus" v-bind:class="getClassName + 'Message'">
            {{message}}
        </div>
        <div v-if="isStatus" v-bind:class="getClassName + 'Message'">
            <div
                v-for="(item,index) in message"
                v-bind:key="index">                
                <span class="matrix_informationLabel">{{index}} {{item}}</span>
            </div>
        </div>
    </div>
</div>

